export { default } from "@/features/profile/screens/user-events-list";
